import { CircularProgress } from "@material-ui/core";
import { useEffect, useState } from "react";
import Question from "../../components/Question/Question";
import "./Quiz.css";
import Timer from "../../components/Timer/Timer";

const Quiz = ({ name, timer, questions, score, setScore, setQuestions, activities, setActivities, correctQuestions, setCorrectQuestions }) => {
  const [options, setOptions] = useState();
  const [currQues, setCurrQues] = useState(0);
  const [totalTime, setTotalTime] = useState();

  

  useEffect(() => {
    const handleShuffle = (arr) => {
      if (arr.length === 1) {return arr};
      const rand = Math.floor(Math.random() * arr.length);
      return [arr[rand], ...handleShuffle(arr.filter((_, i) => i !== rand))];
    };

    setOptions(
      questions &&
        handleShuffle([
          questions[currQues]?.correct_answer,
          ...questions[currQues]?.incorrect_answers,
        ])
    );
    questions && localStorage.setItem('quiz', questions[currQues].quiz_name)
  }, [currQues, questions]);

  if (!totalTime) {
    let time = new Date();
    time.setSeconds(time.getSeconds() + timer);
    setTotalTime(time); 
  }

  return (
    <div className="quiz">
      <span className="subtitle">{questions ? questions[currQues].quiz_name : 'Loading Quiz'}</span>

      {questions ? (
        <>
          <div className="quizInfo">
            <span>{name}</span>
          </div>
          <div>
            <span className="timer">TIME REMAINING<br/>
              <Timer startDate={+new Date(totalTime)}/>
            </span>
          </div>
          <Question
            currQues={currQues}
            setCurrQues={setCurrQues}
            questions={questions}
            options={options}
            correct={questions[currQues]?.correct_answer}
            score={score}
            setScore={setScore}
            setQuestions={setQuestions}
            activities={activities}
            setActivities={setActivities}
            correctQuestions={correctQuestions}
            setCorrectQuestions={setCorrectQuestions}
          />
        </>
      ) : (
        <CircularProgress
          style={{ margin: 100 }}
          color="inherit"
          size={150}
          thickness={1}
        />
      )}
    </div>
  );
};

export default Quiz;
